import React from 'react';
import { cn } from '../../lib/cn';
import { Icon } from '../Icon/Icon';
import type { IconKind } from '../Icon/Icon';

export type SegmentedOption = string | { value?: string; label?: React.ReactNode; icon?: IconKind };
export interface SegmentedProps {
  options: SegmentedOption[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
  /** Opt-in glossy active item (Calendar controls); default is the plain white pill. */
  glossy?: boolean;
}

export function Segmented({ options, value, onChange, className, glossy }: SegmentedProps) {
  return (
    <div
      className={cn(
        'inline-flex gap-1 rounded-[var(--r-pill)] border border-[var(--cream-2)] bg-[var(--cream-0)] p-1',
        className
      )}
    >
      {options.map((option, index) => {
        const item =
          typeof option === 'string'
            ? { value: option, label: option }
            : {
                value: option.value ?? `segment-${String(index)}`,
                label: option.label,
                icon: option.icon,
              };
        const active = item.value === value;
        return (
          <button
            key={item.value}
            onClick={() => {
              onChange(item.value);
            }}
            className={cn(
              'inline-flex cursor-pointer items-center gap-[7px] rounded-[var(--r-pill)] px-[15px] py-[7px] text-[13px] font-semibold transition',
              active
                ? glossy
                  ? 'glass-segment-active'
                  : 'bg-[var(--cream-1)] text-[var(--ink-0)] shadow-[0_1px_2px_rgba(0,0,0,0.08)]'
                : 'text-[var(--ink-3)]'
            )}
          >
            {item.icon ? <Icon kind={item.icon} size={14} stroke={2} /> : null}
            {item.label}
          </button>
        );
      })}
    </div>
  );
}
